export const ORG_LOCK_BANNER_HEIGHT = '54px';
